import { all, takeLatest, call, put } from 'redux-saga/effects'

import * as actionTypes from './action-types'
import * as actionTypesError from '../errors/action-types'

import { fetchVendorDetails } from './api'

function* fetchVendorDetailsSaga({ payload: { id } }) {
  yield put({ type: actionTypes.RESET_VENDOR_INFO })
  try {
    const response = yield call(fetchVendorDetails, id)

    yield put({ type: actionTypes.FETCH_VENDOR_DETAILS_SUCCESS })
    yield put({ type: actionTypes.GET_VENDOR_INFO, payload: response })
  } catch (e) {
    yield put({
      type: actionTypes.FETCH_VENDOR_DETAILS_ERROR,
      payload: e.message,
    })
    yield put({ type: actionTypesError.ERROR, payload: { error: e } })
  }
}

export default function* rootSaga() {
  yield all([takeLatest(actionTypes.GET_VENDOR_ID, fetchVendorDetailsSaga)])
}
